import React, { FC } from 'react';
import { RouteComponentProps, Switch, Redirect } from 'react-router-dom';

import PruRoute from 'src/app/common/components/PruRoute';
import ParamsProvider from 'src/app/common/components/ParamsProvider';
import { ModulePermissionProps } from 'src/app/common/module/types';
import { ACTIVITY_TRACKING_BASE_PATH, QR_CODE_ACTIVITY_TYPE_PATH } from '../../constans';

import QRCodeActivityTypeListPage from './List';
import QRCodeActivityTypeDetailPage from './Detail/QRCodeActivityTypeDetailPage';

const basePath = `${ACTIVITY_TRACKING_BASE_PATH}${QR_CODE_ACTIVITY_TYPE_PATH}`;

export const qrCodeActivityTypeFilterKeys = [
  'name',
  'category',
  'accessibility',
  'framework',
  'createdAtFrom',
  'createdAtTo',
  'status',
  'categoryId',
];

const QRCodeActivityTypePage: FC<RouteComponentProps & ModulePermissionProps> = ({
  enableRead,
  enableCreate,
  enableUpdate,
}) => {
  return (
    <Switch>
      <Redirect exact from={basePath} to={`${basePath}/list`} />

      <PruRoute
        exact
        path={`${basePath}/list`}
        render={(props) => (
          <ParamsProvider {...props} acceptKeys={qrCodeActivityTypeFilterKeys}>
            <QRCodeActivityTypeListPage
              enableRead={enableRead}
              enableCreate={enableCreate}
              enableUpdate={enableUpdate}
            />
          </ParamsProvider>
        )}
      />

      <PruRoute
        exact
        path={`${basePath}/create`}
        render={(props) => (
          <QRCodeActivityTypeDetailPage
            {...props}
            mode="create"
            enableRead={enableRead}
            enableCreate={enableCreate}
            enableUpdate={enableUpdate}
          />
        )}
      />

      <PruRoute
        exact
        path={`${basePath}/edit/:id`}
        render={(props) => (
          <QRCodeActivityTypeDetailPage
            {...props}
            mode="edit"
            enableRead={enableRead}
            enableCreate={enableCreate}
            enableUpdate={enableUpdate}
          />
        )}
      />

      <PruRoute
        exact
        path={`${basePath}/view/:id`}
        render={(props) => (
          <QRCodeActivityTypeDetailPage
            {...props}
            mode="view"
            enableRead={enableRead}
            enableCreate={enableCreate}
            enableUpdate={enableUpdate}
          />
        )}
      />
    </Switch>
  );
};

export default QRCodeActivityTypePage;
